import { ICalculationGuestUpdate } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

interface IProps {
  calculationId: string;
  guestId?: string;
  payload: ICalculationGuestUpdate;
}

export const upsertCalculationGuest = ({
  calculationId,
  guestId,
  payload,
}: IProps): Promise<any> => {
  if (guestId === undefined) {
    return API.post(`api/accommodation/calculations/${calculationId}/guests`, payload).then(
      response => response?.data,
    );
  }

  return API.put(`api/accommodation/calculations/${calculationId}/guests/${guestId}`, payload).then(
    response => response?.data,
  );
};
